&nbsp;


// WEBPACK FOOTER //
// ./node_modules/angular2-highcharts/dist/ChartComponent.d.ts.ChartComponent.html